import { HttpParams } from '@angular/common/http';

export function cleanUpHttpParams(httpParams: HttpParams): HttpParams {
  for (const key of httpParams.keys()) {
    if (httpParams.get(key) === undefined || httpParams.get(key) === null || httpParams.get(key) === "") {
      httpParams = httpParams.delete(key, undefined);
    }
  }

  return httpParams;
}

export function toCleanHttpParams(params: {}): HttpParams {
  const httpParams: HttpParams = new HttpParams({ fromObject: params });

  return cleanUpHttpParams(httpParams);
}
